import ToggleBtn from "components/button/toggle/toggle";
import { useAuthContext } from "components/context/authContext";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MouseEvent } from "react";
import { useMutation } from "@tanstack/react-query";
import { logoutApi } from "components/api/user";
import { alertControl, successControl } from "util/commAction";

export default function AuthActionBtn() {
  const { t } = useTranslation();
  const { isLogin, setIsLogin } = useAuthContext();

  const logoutMutation = useMutation({
    mutationFn: logoutApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            const removeItem = ["userInf", "lodInf"];
            removeItem.forEach((item) => {
              localStorage.removeItem(item);
            });
            setIsLogin(false);

            sessionStorage.removeItem("isLogin");
          },
        });
      }
    },
  });

  const handleLogout = (e: MouseEvent<HTMLLIElement>) => {
    // 로그아웃
    const parent = e.currentTarget.closest("div") as HTMLDivElement;
    parent.className = "";
    parent.style.height = 0 + "px";

    alertControl({
      isOpen: true,
      inner: t("alr_logout"),
      cncl_btn: true,
      click: () => {
        logoutMutation.mutate();
      },
    });
  };

  const handleClick = (e: MouseEvent<HTMLLIElement>) => {
    const parent = e.currentTarget.closest("div") as HTMLDivElement;
    parent.className = "";
    parent.style.height = 0 + "px";
  };

  return (
    <>
      {/* 회원가입  */}
      {!isLogin && <Link to="join">{t("lst_hd_sgn")}</Link>}

      {/* 마이페이지 */}
      {isLogin && (
        <ToggleBtn text={t("lst_hd_mpg")}>
          <ul className="_menu_inf">
            <li onClick={handleClick}>
              <Link to="mypage">{t("lst_hd_us_info")}</Link>
            </li>
            <li onClick={handleClick}>
              <Link to="mypage/resv">{t("lst_hd_bk")}</Link>
            </li>
            {/* <li onClick={handleClick}>
              <Link to="mypage/hotel">{t("lst_hd_htl")}</Link>
            </li> */}
            <li onClick={handleLogout}>{t("lst_hd_lgo")}</li>
          </ul>
        </ToggleBtn>
      )}
    </>
  );
}
